module.exports = __webpack_public_path__ + "img/perfil.b900da95.png";